if ($(".c-navbtab").length > 0) {
    const $navtab = {
        btn: $(".c-navbtab__btns--item button"),
        content: $(".c-navbtab__content--item"),
        activeClass: 'js-isActive',
    }

    $navtab.btn.click(function () {

        const $current_btn = $(this);
        const $current_data = $(this).data("navtab-index");

        $navtab.btn.each(function () {
            if (!$current_btn.hasClass($navtab.activeClass)) {
                $(this).removeClass($navtab.activeClass);
            }
        });

        $navtab.content.each(function () {
            $(this).removeClass($navtab.activeClass);
        });

        if (!$(this).hasClass($navtab.activeClass)) {
            $(this).addClass($navtab.activeClass);
            $(".c-navbtab__content--item[data-navtab-index='" + $current_data + "']").addClass($navtab.activeClass);
        } else {
            //$(this).removeClass($navtab.activeClass);
        }
    });
}
